// src/pages/admin/roles/AddRole.tsx
import React from "react";
import { useForm } from "react-hook-form";
import RoleForm, { RoleFormData } from "../../../components/admin/roles/RoleForm";
import SubmitButton from "../../../components/form/SubmitButton";
import MainTitle from "../../../components/ui/MainTitle";
import { useUpdateResource } from "../../../hooks/useUpdateResource";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import LoadingButton from "../../../components/form/LoadingButton";

function AdminAddRole() {
    const { register, handleSubmit, formState: { errors } , setValue ,watch} = useForm<RoleFormData>();

    const {t} = useTranslation();
    const navigate = useNavigate();

   const { loading, updateResource } = useUpdateResource();
  
    const onSubmit = (data: RoleFormData) => {
      updateResource(`role`, {name:data.title,permissions:data.permissions},
          "admin",{
              method: "POST",
              successMessage: t("createdSuccess"),
              invalidateQueries:["roles-by-admin"],
              navigateAfter: () => navigate(`/admin/roles`),
            });
    };

  return (
    <div className="p-4">
      <form onSubmit={handleSubmit(onSubmit)}  className="flex flex-col gap-4 w-full">
        <MainTitle title="add_new_role" />
        <RoleForm register={register} errors={errors} setValue={setValue} watch={watch}/>
        {
            loading
            ?
            <LoadingButton/>
            :
            <SubmitButton label="create"/>
        }
      </form>
    </div>
  );
}

export default AdminAddRole;
